import { Stack, Typography } from "@mui/material";
import React from "react";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import * as Sentry from "@sentry/react";
import { ErrorBoundary } from "react-error-boundary";

interface Props {
  children: React.ReactNode;
}

const OopsSomethingWentWrong = () => {
  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      height={"100%"}
      gap={2}
      pl={2}
      pr={2}
    >
      <WarningAmberIcon sx={{ fontSize: "48px" }} />
      <Typography variant="h4" textAlign="center">
        Aaaah! Something went wrong
      </Typography>
      <Typography textAlign="center">
        Brace yourself till we get the error fixed. You may also refresh the
        page оr try again later.
      </Typography>
    </Stack>
  );
};

const ErrorBoundaryProvider = ({ children }: Props) => {
  if (import.meta.env.DEV === true) {
    return (
      <ErrorBoundary fallback={<OopsSomethingWentWrong />}>
        {children}
      </ErrorBoundary>
    );
  }

  return (
    <Sentry.ErrorBoundary fallback={<OopsSomethingWentWrong />}>
      {children}
    </Sentry.ErrorBoundary>
  );
};

export default ErrorBoundaryProvider;
